import React from "react";

import { Button } from "../../../components/Field";
import Link from "../../../components/Link";
import Title from "../../../components/Title";
import Editor from "../../../components/Editor";
import Section from "../../../components/Section";
import Background from "../../../components/Background";

import style from "./style.module.css";

export default function LandingBanner(props) {
    const {
        bg_image = [],
        title = "",
        description = "",
        button_label = "",
        button_link = "",
    } = props;
    return (
        <Section className={style.landingBanner}>
            <div className={style.slider}>
                <Link className={style.fullBlock} to={button_link}></Link>
                <Background src={bg_image} size="2560x1440" cPosition="topLeft" />
                <div className={`${style.sectionRow}`}>
                    <div className={`${style.sectionTextContent}`}>
                        {
                            title !== "" && (
                                <Title
                                    tag="h6"
                                    className="bigTitle"
                                    transform="uppercase"
                                    align="center"
                                >
                                    {title}
                                </Title>
                            )
                        }
                        {
                            description !== "" && (
                                <div className={style.description}>
                                    <Editor text={description} />
                                </div>
                            )
                        }
                        {
                            button_label !== null && button_link !==  null && (
                                <div className={style.buttonRow}>
                                    <Button
                                        label={button_label}
                                        link={button_link}
                                        color="buttonPrimary"
                                        size="buttonBig"
                                    />
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
        </Section>
    )
}